export default function (Component) {
Component.options.__tip = "<p>You can customize the names (day of week and month of year)  displayed in the calendar by using the props <code>dayNames</code> and <code>monthNames</code>. This is also how you would implement i18n.</p>\n"
}